import { useEffect, useState } from 'react';

export const BACKTEST_SYMBOL_DEBOUNCE_MS = 300;

const useDebouncedValue = (value, delay = BACKTEST_SYMBOL_DEBOUNCE_MS) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timeout = window.setTimeout(() => setDebouncedValue(value), delay);
    return () => window.clearTimeout(timeout);
  }, [delay, value]);

  return debouncedValue;
};

export default useDebouncedValue;
